import { Box } from '@chakra-ui/react';

export const UnderlineLink = (props) => {
  return (
    <Box
      pos="relative"
      display="inline-block"
      transition="opacity 0.2s"
      _hover={{
        opacity: 0.8,
      }}
      _after={{
        content: `""`,
        display: 'block',
        h: '2px',
        bottom: 0,
        bg: 'primary',
        insetX: 0,
        insetY: 0,
      }}
      {...props}
    />
  );
};
